import {
	createHook,
} from 'react-sweet-state';

import {
	companyTaxSettingsStore,
} from './company-tax-settings-store';

export const useCompanyTaxSettingsStore = createHook(companyTaxSettingsStore);
